/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
const extractUrls = require("extract-urls");

export const DescriptionComponent = ({ text }) => {
    const [data, setData] = useState([{
        type: "text",
        value: ""
    }]);
    const updateData = () => {
        if (text && text != "") {
            const urls = extractUrls(text);
            if (urls && urls.length > 0) {
                let result = [];
                let count = 0;
                let current_text = text;
                for (const url of urls) {
                    count = 0;
                    let spl = current_text.split(url);
                    let pos = current_text.indexOf(url)
                    if (spl.length > 0) {
                        current_text = spl.at(-1);
                    }
                    for (const txt of spl) {
                        if (count == pos) {
                            result.push({
                                type: "url",
                                value: url
                            })
                        }
                        if (txt != current_text) {
                            result.push({
                                type: "text",
                                value: txt
                            })
                            count += txt.length;
                        }
                    }
                }
                setData(result);
            } else {
                setData([{
                    type: "text",
                    value: text
                }])
            }
        } else {
            setData([{
                type: "text",
                value: ""
            }])
        }
    }
    useEffect(() => {
        updateData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [text]);
    return (
        <React.Fragment>
            {data.map(el => {
                if (el.type == "text") {
                    return (<React.Fragment>{el.value}</React.Fragment>)
                } else {
                    return (<a target={"_blank"} href={el.value}>{el.value}</a>)
                }
            })}
        </React.Fragment>
    );
}